// extracted by mini-css-extract-plugin
export default {"underlineAchildren":"DocumentAlertItem_underlineAchildren__4YXba"};